// project-imports
import { getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - SETTINGS ||============================== //

export async function handleSettings(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/settings', action.data);
    case 'read':
      return getRequest(`/settings?type=${action.data.type}&entity=${action.data.entity}&entity-id=${action.data.entityId}`);
    case 'update':
      return putRequest(`/settings/${action.id}`, action.data);
    case 'feed-estimations':
      return getRequest(`/settings/feed-estimations?agent-id=${encodeURIComponent(action.data.agentId)}`);
    case 'calculate-feed-estimations':
      return postRequest('/settings/feed-estimations/calculate', action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleSettings] - Unknown method');
      break;
  }
}
